// extracted by mini-css-extract-plugin
export default {"scTable":"TeamSchedules_scTable__LqT2H"};